// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__LJxA2","fileBtn":"File_fileBtn__2qArP","closeBtn":"File_closeBtn__1PVIN","fileSelected":"File_fileSelected__35xxN","disabled":"File_disabled__3MKCU"};